export const DOCUMENT_LIST_GENERIC_ACTIVITY_LIST_SORT = 'DOCUMENT_LIST_GENERIC_ACTIVITY_LIST_SORT';

export const DOCUMENT_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE =
	'DOCUMENT_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE';
